// extracted by mini-css-extract-plugin
export default {"savedCitiesList":"SuggestedCities_savedCitiesList__sBxe-","savedCity":"SuggestedCities_savedCity__hPMKW"};